export default {
    '--full-color': '#69b04d',
    '--light-color': '#69b04d99',
    '--main-content-grid': '#F2F2F2',
    '--title-color': 'rgba(0, 0, 0, 0.87)',
    '--icon-color': '#69b04d',
    '--grid-bg-color': '#69b04d55',
    '--text-input-bg-color': 'rgba(217,217,217,0.53)',
    '--avatar-background': 'linear-gradient(to right, #69b04d99, #69b04d)',
    '--reserve-background': 'linear-gradient(234deg, #69b04d 20%, #69b04d 35%)',
   '--icon-theme-filter': 'invert(32%) sepia(190%) saturate(510%) hue-rotate(45deg) brightness(94%) contrast(115%)',
    '--login-layout-background': 'linear-gradient(234deg, #69b04d 20%, #69b04d 35%)',
    '--lbl-focused-color': '#69b04d',
    '--focused-fieldset-color': 'rgba(105,176,77,0.5)',
    '--input-border-error-color': '#F04924',
    '--checkbox-color': '#69b04d',
    '--color-white': '#ffffff',
    '--txt-disabled': '#ffffff',
    '--txt-success': '#69b04d',
    '--txt-error': 'rgba(255,125,98,0.7)',
    '--disabled-bg': 'rgba(255,86,86,0.03)',
    '--txt-default': '#797979',
    '--link-color': '#69b04d',
    '--txt-gray-color': '#797979',
    '--active-box-background': 'linear-gradient(180deg, #69b04d 0%, #69b04d 100%)',
    '--scrollbar-bg': 'linear-gradient(200deg, #69b04d, #69b04d)',
    '--active-item-background-color': 'rgba(105,176,77,0.15)',
    '--input-number-border-color': '#69b04d',
    '--input-number-focused-border-color': '#69b04d',
    '--grid-view-background': 'linear-gradient(180deg, #fefefe 0%, #fefefe 100%)',
    '--card-view-background': 'linear-gradient(180deg, #ffffff 0%, #ffffff 100%)',
    '--btn-bg-hover': '#69b04d',
    '--btn-success-background': 'linear-gradient(273.72deg, #69b04d 5.88%, #69b04d 128.9%)',
    '--btn-success-border-color': '#69b04d',
    '--btn-gray-background-color': '#a4a4a4',
    '--btn-gray-border-color': '#aaaaaa',
    '--btn-disabled-border-color': '#e8e8e8',
    '--tab-background': 'linear-gradient(180deg, #69b04d 0%, #69b04d 100%)',
    '--tab-indicator-background': 'transparent',
    '--tab-shadow': '0 4px 8px 1px rgba(85, 178, 100, 0.08)',
    '--btn-shadow': '0 4px 18px 1px rgba(87, 182, 92, 0.51)',
    '--card-shadow': '0 4px 6px 0 #69b04d35',
    '--input-background-color': '#69b04d',
    '--select-border-color': 'rgba(89,89,89,0.8)',
    '--select-bg-color': 'rgba(236,234,234,0.9)',
    '--select-text-color': 'rgba(0,0,0,0.9)',
    '--loading-color': '#69b04d',
    '--redial-gradient': '#68af4c',
}